/** Orgs kept in the DB but omitted from public directories, map, and public listings. */

const HIDDEN_EMAILS = new Set([
  'info@triareaministry.com',
  'dcfp@ccharitiesdor.org',
  'salarmydurham@gmail.com',
  'communication@foodbankcenc.org',
  'donorservices@foodbankcenc.org',
  'parktownhub@gmail.com',
  'info@tablenc.org',
  'joy@emanuelfoodpantry.org',
  'info@ifcmailbox.org',
  'info@umdurham.org',
  'feedback@weaverstreetmarket.coop',
  'vendors@weaverstreetmarket.coop',
  'info@durham.coop',
  'info@patelbros.com',
  'raleigh@grandasiamarket.com',
  'jmariakakis@gmail.com',
  'customer_care@hmart.com',
])

const HIDDEN_NAME_FRAGMENTS = [
  'tri-area ministry',
  'triarea ministry',
  'durham community food pantry',
  'salvation army',
  'food bank cenc',
  'foodbankcenc',
  'food bank of central',
  'parktown',
  'tablenc',
  'table, inc',
  'table ministries',
  'emanuel food pantry',
  'immanuel food pantry',
  'inter-faith council',
  'interfaith council',
  'durham shelter for hope',
  'urban ministries of durham',
  'weaver street',
  'durham co-op',
  'durham coop',
  'patel brothers',
  'grand asia',
  'mariakakis',
  'h mart',
  'hmart',
]

function nameMatches(name: string): boolean {
  const normalized = name.toLowerCase().trim()
  if (!normalized) return false
  if (normalized === 'table' || normalized.startsWith('table ')) return true
  return HIDDEN_NAME_FRAGMENTS.some((fragment) => normalized.includes(fragment))
}

export function isHiddenDirectoryOrg(org: {
  email?: string | null
  publicContactEmail?: string | null
  organizationName?: string | null
  name?: string | null
  firstName?: string | null
  lastName?: string | null
  supplier?: {
    email?: string | null
    firstName?: string | null
    lastName?: string | null
    organizationName?: string | null
  } | null
}): boolean {
  const emails = [org.email, org.publicContactEmail, org.supplier?.email]
    .filter((value): value is string => Boolean(value && value.trim()))
    .map((value) => value.trim().toLowerCase())
  if (emails.some((email) => HIDDEN_EMAILS.has(email))) return true

  const names = [
    org.organizationName,
    org.name,
    [org.firstName, org.lastName].filter(Boolean).join(' '),
    org.supplier?.organizationName,
    [org.supplier?.firstName, org.supplier?.lastName].filter(Boolean).join(' '),
  ]
  return names.some((name) => nameMatches(name || ''))
}
